export { default } from "./ClearIcon";
